
export default function Home() {
    return (
        <section className='home' id='home'>
            <div className="homeLeft">
                <h3 className="designation"><span className='color'>Mern Stack</span> Developer</h3>
                <h1 className="about">Hello, I am <span className='color'>Kashish Goyal</span><br></br>
                    who loves to code!</h1>
            </div>
            <div className="homeRight">
                <img src='https://media.tenor.com/lNtmoshuUI8AAAAi/bahroo-hacker.gif' alt="MyImage" className='myImage' />
            </div>
        </section>
    )
}